import React from 'react';
import styled from 'styled-components';
import { themeV2 } from '../styles/themeV2';

const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: ${themeV2.typography.fontFamily.sans.join(', ')};
  text-decoration: none;
  
  ${props => {
    const variant = props.variant || 'primary';
    const size = props.size || 'medium';
    
    // Variant styles
    let variantStyles = '';
    if (variant === 'primary') {
      variantStyles = `
        background: ${themeV2.colors.slate[900]};
        color: ${themeV2.colors.white};
        &:hover {
          background: ${themeV2.colors.slate[800]};
        }
      `;
    } else if (variant === 'secondary') {
      variantStyles = `
        background: transparent;
        color: ${themeV2.colors.slate[900]};
        border: 1px solid ${themeV2.colors.slate[200]};
        &:hover {
          background: ${themeV2.colors.slate[50]};
        }
      `;
    } else if (variant === 'white') {
      variantStyles = `
        background: ${themeV2.colors.white};
        color: ${themeV2.colors.slate[900]};
        &:hover {
          background: ${themeV2.colors.slate[100]};
        }
      `;
    }
    
    // Size styles
    let sizeStyles = '';
    if (size === 'small') {
      sizeStyles = `
        height: 2.25rem;
        padding: 0 1rem;
        font-size: ${themeV2.typography.fontSize.sm};
        border-radius: ${themeV2.borderRadius['2xl']};
      `;
    } else if (size === 'medium') {
      sizeStyles = `
        height: 2.75rem;
        padding: 0 1.25rem;
        font-size: ${themeV2.typography.fontSize.sm};
        border-radius: ${themeV2.borderRadius['2xl']};
      `;
    } else if (size === 'large') {
      sizeStyles = `
        height: 3rem;
        padding: 0 1.5rem;
        font-size: ${themeV2.typography.fontSize.base};
        border-radius: ${themeV2.borderRadius['2xl']};
      `;
    }
    
    return variantStyles + sizeStyles;
  }}
  
  font-weight: ${themeV2.typography.fontWeight.medium};
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const ButtonV2 = ({ children, variant = 'primary', size = 'medium', ...props }) => {
  return (
    <StyledButton variant={variant} size={size} {...props}>
      {children}
    </StyledButton>
  );
};

export default ButtonV2;